import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";
import { useQueryClient } from "react-query";

type ProgressFavoriteRequest = {
  title: string;
  progressNote: string;
};

function useAddProgressFavorite() {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    ["addProgressFavorite"],
    (payload: ProgressFavoriteRequest) =>
      axiosChartInstance.post(`v1/chart-progress-favorite/`, payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["progressFavorites"]);
      },
    }
  );
}

export { useAddProgressFavorite };
export type { ProgressFavoriteRequest };
